module.exports = __webpack_public_path__ + "assets/images/gender_r.2c29fe33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/gender_r.png
// module id = 715
// module chunks = 1